var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWowMythicPlusKeyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8h-4.341a6 6 0 110-4H22v4h-2v4h-4V8zM6 8a2 2 0 100-4 2 2 0 000 4z"
  })));
}
export default __webpack_public_path__ + "static/svg/wow-mythic-plus-key-icon.svg";
export { SvgWowMythicPlusKeyIcon as ReactComponent };